/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Error } from '../../models/error';
import { File } from '../../models/file';

export interface ApiEnrolmentFillEnrolmentsMissingInstitutionsPost$Params {
      body: File
}

export function apiEnrolmentFillEnrolmentsMissingInstitutionsPost(http: HttpClient, rootUrl: string, params: ApiEnrolmentFillEnrolmentsMissingInstitutionsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
  const rb = new RequestBuilder(rootUrl, apiEnrolmentFillEnrolmentsMissingInstitutionsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Error>;
    })
  );
}

apiEnrolmentFillEnrolmentsMissingInstitutionsPost.PATH = '/api/enrolment/fill-enrolments-missing-institutions';
